<template>
	<div>
		<v-text-field
			v-bind="$attrs"
			v-on="fieldListeners"
			:type="isVisible ? 'text' : 'password'"
			:value="value"
			:rules="mergedRules"
			:append-icon="isVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"
			autocomplete="new-password"
			@click:append="toggleVisibility"
			@paste="disablePaste"
			@copy="disableCopy"
			@cut="disableCut"
			@contextmenu="disableContextMenu"
		/>

		<password-guidance
			v-if="showGuidance"
			:password="value"
			:rejection-errors="rejectionErrors"
		/>
	</div>
</template>

<script>
import PasswordGuidance from "./PasswordGuidance.vue"
import { passwordRules } from "../utils/passwordPolicy"

export default {
	name: "SecurePasswordField",

	components: {
		PasswordGuidance,
	},

	inheritAttrs: false,

	props: {
		value: {
			type: String,
			default: "",
		},

		rules: {
			type: Array,
			default: () => [],
		},

		showGuidance: {
			type: Boolean,
			default: true,
		},

		rejectionErrors: {
			type: Array,
			default: () => [],
		},

		denseGuidance: {
			type: Boolean,
			default: false,
		},

		visible: {
			type: Boolean,
			default: false,
		},

		enforcePolicy: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			// local, toggleable copy of the `visible` prop
			isVisible: this.visible,
		}
	},

	watch: {
		// keep in sync if parent changes the prop externally
		visible(val) {
			this.isVisible = val
		},
	},

	computed: {
		mergedRules() {
			const base = this.enforcePolicy
				? passwordRules()
				: []

			return [...base, ...this.rules]
		},

		fieldListeners() {
			const vm = this

			return {
				...this.$listeners,

				input(val) {
					vm.$emit("input", val)
				},
			}
		},
	},

	methods: {
		toggleVisibility() {
			this.isVisible = !this.isVisible
			this.$emit("update:visible", this.isVisible)
		},

		disablePaste(e) {
			e.preventDefault()

			this.$emit(
				"blocked-action",
				"Paste is disabled for this password field."
			)
		},

		disableCopy(e) {
			e.preventDefault()

			this.$emit(
				"blocked-action",
				"Copy is disabled for this password field."
			)
		},

		disableCut(e) {
			e.preventDefault()

			this.$emit(
				"blocked-action",
				"Cut is disabled for this password field."
			)
		},

		disableContextMenu(e) {
			e.preventDefault()
		},
	},
}
</script>